import { SVGProps } from 'react';

export const Chat = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 4.88086H1.5C0.67275 4.88086 0 5.55361 0 6.38086V13.1309C0 13.9581 0.67275 14.6309 1.5 14.6309H2.25V17.6309L6.24975 14.6309H11.25C12.0772 14.6309 12.75 13.9581 12.75 13.1309V10.8291C9.79125 10.4586 7.5 7.94011 7.5 4.88086Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 0.369141C11.0182 0.369141 9 2.38814 9 4.86914C9 7.35014 11.0182 9.36914 13.5 9.36914C15.9818 9.36914 18 7.35014 18 4.86914C18 2.38814 15.9818 0.369141 13.5 0.369141Z"
      fill="#2FCFD3"
    />
  </svg>
);
